import { Flex, Text } from "@/atoms"
import { IconStep } from "./IconStep"

import styles from "./OverviewStepsAdr.module.scss"

import type { StepsProps } from "."

export const StepsTemplate = (props: StepsProps) => {
  const { items } = props
  const lastIndex = items.length - 1

  return (
    <Flex vertical gap={24}>
      {items.map((item, index) => (
        <Flex key={item.key || index} className={styles.stepItem}>
          <Flex flex="0 0 39px" justify="center" className={styles.stepIcon}>
            <Text>
              <IconStep {...item} />
            </Text>
            {index !== lastIndex && <span className={styles.stepIconTail} />}
          </Flex>
          <Flex
            vertical
            flex={1}
            align="start"
            gap="2px"
            className={styles.stepItemWrapper}
          >
            {item.title}
            {item.description}
          </Flex>
        </Flex>
      ))}
    </Flex>
  )
}
